import ReactDOMServer from 'react-dom/server';

import { DEFAULT_EMPTY_LABEL, INLINE_IMAGE_DATA_ATTRIBUTE } from './Config/inbox.config';

import { SVG_ICONS } from '../../common/Elements/Icon/SVGIcons';

export function getUserFullNameFromDocument(user) {
  return user ? `${user.firstName} ${user.lastName}` : DEFAULT_EMPTY_LABEL;
}

export function mapTagWorkstreamToWorkstreams(workstreamTag) {
  return workstreamTag.length ? workstreamTag.map((ws) => ws.tagWorkstream.workstream) : [];
}

export function mapTagWorkstreamToTagWorkstream(workstreamTag) {
  return workstreamTag.length
    ? workstreamTag.map((ws) => ({
        value: ws.tagWorkstream.id,
        label: ws.tagWorkstream.workstream,
        color: ws.tagWorkstream.color,
      }))
    : [];
}

export function mapTaskListToTasks(taskTag) {
  return taskTag.length ? taskTag.map((ws) => ws.name) : [];
}

export function mapTagTaskToTasklist(taskTag) {
  return taskTag.length
    ? taskTag.map((ws) => ({
        id: ws.tagTask.id,
        status: ws.tagTask.status,
        name: ws.tagTask.task,
      }))
    : [];
}

export const parseInlineImages = (htmlString: string) => {
  const sanitizedEditorContent = htmlString.replace(/\ssrc="cid:[^"]+"/g, (match) => {
    const cid = match.slice(10, -1);
    const regex = new RegExp(`${INLINE_IMAGE_DATA_ATTRIBUTE}="${cid}[^"]+"`, 'g');
    const dataFilename = htmlString.match(regex);
    if (!dataFilename) return match;

    const filename = dataFilename[0].slice(INLINE_IMAGE_DATA_ATTRIBUTE.length + 2, -1);
    return ` src="/api/file/upload/${filename}"`;
  });
  return sanitizedEditorContent;
};

export const replaceImageWithIconPlaceHolder = (text) => {
  return text.replace(
    /\[(image:[^\]]+|cid:[^\]]+|https?:\/\/[^\]]+)\]/g,
    ReactDOMServer.renderToString(SVG_ICONS.image_thumbnail({}))
  );
};
